<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M58.5 13.67a2 2 0 00-2.08-.84L6.61 23.34a2 2 0 00-1 3.39L16 36.7v14a2 2 0 003.46 1.36l6-6.35 5.13 4.94a2 2 0 001.38.55h.18a2 2 0 001.44-.82l24.89-34.45a2 2 0 00.02-2.26zm-9 3.69L18.27 34.69v.06l-9.19-8.87zM19 48.21v-8.63l4.25 4.09zm12.79-.49L20.51 36.88l32-17.76z"/></svg>